export default {"src":"/_next/static/media/image-apostle-minted-frame.daa079cc.svg","height":263,"width":172,"blurWidth":0,"blurHeight":0};